import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { LogoService } from "../../../util/service/logo.service";
import { ActivatedRoute, Router } from "@angular/router";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "app-loading",
    imports: [],
    templateUrl: "./loading.component.html",
    styleUrl: "./loading.component.scss"
})
export class LoadingComponent implements OnInit, OnDestroy {
  public coreConfig: any;
  redirectTimeout: number;
  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param logoService
   * @param _route
   * @param router
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    public logoService: LogoService,
    private _route: ActivatedRoute,
    private router: Router
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  get returnUrl() {
    const returnUrl = this._route.snapshot.queryParams["returnUrl"] || "/";
    return returnUrl === "/error" ? "/" : returnUrl;
  }

  /**
   * On init
   */
  ngOnInit(): void {
    const isPageReload = sessionStorage.getItem("isPageReload");
    if (isPageReload === "true") {
      sessionStorage.setItem("isPageReload", "false");
      this.router.navigate([this.returnUrl]);
    }

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      this.coreConfig = config;
    });

    this.redirectTimeout = window.setTimeout(
      () =>
        this.router.navigate(["update"], {
          queryParams: { returnUrl: this.returnUrl },
        }),
      10000
    );
  }

  @HostListener("window:beforeunload", ["$event"])
  beforeUnloadHandler(event: any) {
    sessionStorage.setItem("isPageReload", "true");
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    clearTimeout(this.redirectTimeout);
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
